export default {
  'menu.welcome': '欢迎',
  'menu.more-blocks': '更多区块',
  'menu.home': '首页',
  'menu.admin': '管理页',
  'menu.admin.sub-page': '二级管理页',
  'menu.login': '登录',
  'menu.register': '注册',
  'menu.register-result': '注册结果',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': '分析页',
  'menu.dashboard.monitor': '监控页',
  'menu.dashboard.workplace': '工作台',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表单页',
  'menu.form.basic-form': '基础表单',
  'menu.form.step-form': '分步表单',
  'menu.form.step-form.info': '分步表单（填写转账信息）',
  'menu.form.step-form.confirm': '分步表单（确认转账信息）',
  'menu.form.step-form.result': '分步表单（完成）',
  'menu.form.advanced-form': '高级表单',
  'menu.list': '列表页',
  'menu.list.table-list': '查询表格',
  'menu.list.basic-list': '标准列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.projects': '搜索列表（项目）',
  'menu.list.search-list.applications': '搜索列表（应用）',
  'menu.profile': '详情页',
  'menu.profile.basic': '基础详情页',
  'menu.profile.advanced': '高级详情页',
  'menu.result': '结果页',
  'menu.result.success': '成功页',
  'menu.result.fail': '失败页',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.account': '个人页',
  'menu.account.center': '个人中心',
  'menu.account.settings': '个人设置',
  'menu.account.trigger': '触发报错',
  'menu.account.logout': '退出登录',
  'menu.editor': '图形编辑器',
  'menu.editor.flow': '流程编辑器',
  'menu.editor.mind': '脑图编辑器',
  'menu.editor.koni': '拓扑编辑器',

  // 系统设置
  'menu.system.settings': '系统设置',
  'menu.system.settings.role-management': '角色管理',
  'menu.system.settings.page-auth-management': '页面权限管理',
  'menu.system.settings.account-roles-management': '账号角色设置',
  'menu.system.settings.account-management': '账号管理',
  'menu.system.settings.profile-settings': '个人资料设置',
  'menu.system.settings.feedback-management': '更新信息・反馈管理',

  // 总务部菜单
  'menu.general.affairs': '总务部',
  'menu.general.affairs.attendance-input-onsite': '考勤录入（现场项目）',
  'menu.general.affairs.attendance-input-training': '考勤录入（社内研修）',
  'menu.general.affairs.attendance-list-onsite': '勤怠一覧（现场项目）',
  'menu.general.affairs.attendance-list-training': '勤怠一覧（社内研修）',
  'menu.general.affairs.commute-commit': '通勤费申请',
  'menu.general.affairs.commute-commit-list': '通勤费申请一览',
  'menu.general.affairs.oa-requests': '请假申请',
  'menu.general.affairs.oa-approvals': '请假审批',
  'menu.general.affairs.oa-workflows': '请假审批流程',
  'menu.general.affairs.fixed-assets': '固定资产管理',

  // 人事部菜单
  'menu.human.resources': '人事部',
  'menu.human.resources.employee-personal-update': '员工信息修改',
  'menu.human.resources.dashboard': 'ダッシュボード',
  'menu.human.resources.employee-list-trainee': '研修情報一覧',
  'menu.human.resources.employee-list-regular': '社員情報一覧',
  'menu.human.resources.employee-list-bp': 'BP社員情報一覧',
  'menu.human.resources.employee-list-undefined': '未定情報一覧',
  'menu.human.resources.employee-info-init': '员工信息修改',
  'menu.human.resources.interview-list': '面接信息一览',
  'menu.human.resources.document-requests': '文件申请',
  'menu.human.resources.document-request-management': '文件申请管理',

  // 开发部菜单
  'menu.development': '开发部',
  'menu.development.learn-analytics': '培训数据分析',
  'menu.development.learn-progress': '学员进度一览',
  'menu.development.learn-course': '课程管理',
  'menu.development.learn-player': '学习 / 测试',
  'menu.development.stage-exam': '阶段考核',
  'menu.development.learn-test': '测试页面',
  'menu.development.learn-question': '提问页面',

  // 营业部
  'menu.sales': '营业部',
  'menu.sales.bp-list': '协力公司一览（Business Partner）',
  'menu.sales.bp-sales-list': 'BP营业一览',
  'menu.sales.internal-sales-list': '社内营业一览',
  'menu.sales.invoice-list': '发票一览',
  'menu.accounting': '经理部',
  'menu.accounting.dashboard': '仪表盘',
  'menu.accounting.salary-management': '工资管理',
  'menu.internal-notices': '社内公示・通知',
  'menu.system.settings.internal-notices': '社内公示・通知管理',
};
